var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tailwind Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6 7.2001C15.6 9.18832 13.9882 10.8001 12 10.8001C10.0117 10.8001 8.39995 9.18832 8.39995 7.2001C8.39995 5.21187 10.0117 3.6001 12 3.6001C13.9882 3.6001 15.6 5.21187 15.6 7.2001Z",
    fill: "#310048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6 9.6001C21.6 10.9256 20.5254 12.0001 19.2 12.0001C17.8745 12.0001 16.8 10.9256 16.8 9.6001C16.8 8.27461 17.8745 7.2001 19.2 7.2001C20.5254 7.2001 21.6 8.27461 21.6 9.6001Z",
    fill: "#310048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8 18.0001C16.8 15.3491 14.6509 13.2001 12 13.2001C9.34898 13.2001 7.19995 15.3491 7.19995 18.0001V21.6001H16.8V18.0001Z",
    fill: "#310048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19995 9.6001C7.19995 10.9256 6.12543 12.0001 4.79995 12.0001C3.47447 12.0001 2.39995 10.9256 2.39995 9.6001C2.39995 8.27461 3.47447 7.2001 4.79995 7.2001C6.12543 7.2001 7.19995 8.27461 7.19995 9.6001Z",
    fill: "#310048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2 21.6001V18.0001C19.2 16.7351 18.8737 15.5463 18.3008 14.5133C18.5882 14.4394 18.8895 14.4001 19.2 14.4001C21.1882 14.4001 22.8 16.0119 22.8 18.0001V21.6001H19.2Z",
    fill: "#310048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.69907 14.5133C5.12617 15.5463 4.79995 16.7351 4.79995 18.0001V21.6001H1.19995V18.0001C1.19995 16.0119 2.81173 14.4001 4.79995 14.4001C5.1104 14.4001 5.41167 14.4394 5.69907 14.5133Z",
    fill: "#310048"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.953ebffe97de062177cab8cb83ad2bd3.svg";
export { ForwardRef as ReactComponent };